import React, { useState, useEffect, useCallback, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronUp, faChevronDown, fa1, fa2, fa3, fa4, fa5, fa6, fa7, fa8, fa9, fa0 } from '@fortawesome/free-solid-svg-icons'
import { MostraQuota, calculQuota, setCataleg } from '../quotes'
import Dropdown from '../../dropdown'
import { FormInputText, FormSelectRadio, FormSelectCicle, FormSelectNouAlumne, FormTextArea } from '../formelements'
import { useDropzone } from 'react-dropzone'
import { decode } from 'base-64'
import axios from 'axios'
import config from '../../../config'

const TriaAssignatures = (props) => {

  // el catàleg arriba de forma asíncrona (API); si encara no ha arribat quan es tria
  // curs, evitem petar amb un array buit en comptes d'undefined
  const llistaAssignatures = props.assignaturesCatalog[props.curs.id] || []

  // NYAP, AQUESTA ASSIGNATURA DEPEN DE SI ES TORN MATI O TARDA PER SI ES DE PRIMER O SEGON
  //110.01", "level": 2, "name": "UF1. Empresa i iniciativa emprenedora", "hours": 66 , "assign": "CFPSSAE0" 


 // SI ES CANVIA AIXÒ CAL CANVIAR-HO TAMBÉ A CALCULQUOTES


  if (props.curs.id === "CFPSSAE0" || props.curs.id === "CFPSSAE0A") {

    //console.log('lla', llistaAssignatures)
    llistaAssignatures.map((lla) => {
      if (lla.id === "110") {

        lla.subjects.map((sub) => {

          if (sub.id === "110.01") {

            if (props.torn === "M" && sub.level !== 1) {
              sub.level = 1
            }

            if (props.torn === "T" && sub.level !== 2) {
              sub.level = 2
            }
          }
        })
      }
    })
  }


  const llistaIDSInicialsMarcats = llistaAssignatures.flatMap( (moduls) => moduls.subjects.filter( s => s.SHOWONLY ).map( s => s.id))
  const [isCheckAll, setIsCheckAll] = useState([false, false, false]); // level = 0,1,2
  const [isCheck, setIsCheck] = useState(llistaIDSInicialsMarcats);
  const [only, setOnly] = useState(false);


  const resetCurs = (llista) => {

  setIsCheckAll([false, false, false]);
  setIsCheck(llista);
  props.setOrdreTriat([]);
  setOnly(false)

  }


  useEffect(() => {

    resetCurs(llistaIDSInicialsMarcats)

  },[props.curs.id]) // si canvia el curs, tornema inicialitzar assignatures triades


  //TODO
  const handleSelectAllModule = (mod) => {
    /*

    let newA = [...isCheckAll];

    newA[mod] = !newA[mod];

    setIsCheckAll(newA);

    let allList = []

    if (!isCheckAll[mod]) {

      llistaAssignatures.map((assignatura) => assignatura.subjects.filter(item => item.level === mod).map((subject) => { return allList.push(subject.id) }))

    }

    setIsCheck(allList)
    */
  };

  const handleSelectAllLevel = (level) => {

    let newA = [...isCheckAll];

    newA[level] = !newA[level];

    setIsCheckAll(newA);

    let allList = []
    if(level === "A")
    {
        llistaAssignatures.map((assignatura) => assignatura.subjects.filter(item => item).map((subject) => { return allList.push(subject.id) }))

    }else {

      if (!isCheckAll[level]) {
        
        llistaAssignatures.map((assignatura) => assignatura.subjects.filter(item => item.level === level).map((subject) => { return allList.push(subject.id) }))
        
      }
    }

    setIsCheck(allList)
  };

  const handleClickOnSubject = (id, checked, XOR, ORD) => {

    // Si és assignatura única, forcem només aquesta i amagem les altres, o mostrem les altres al desmarcar.
    if (id === "ONLY") {

      if (checked) {
        setIsCheck([])
        setOnly(false)
        props.setRepetidor()
      }
      else
      {
        setIsCheck([id])
        setOnly(true)
        props.setRepetidor(1)
      }

      return
    }


    if (checked) { // eliminar entrada
      setIsCheck(isCheck.filter(item => item !== id));

      if( ORD ) {
          let isOrdDup = [...props.ordreTriat]

        if(isOrdDup[ORD]){
          let rowORD = isOrdDup[ORD]

          isOrdDup[ORD] = rowORD.filter(item => item !== id)

        props.setOrdreTriat(isOrdDup);
            //console.log("iOD",props.ordreTriat)
        }

      }



    }
    else { //  afegir nova entrada

      if (XOR) {  // si l'assignatura és "exclusiva" marca només aquesta eliminant la resta

        //console.log(id)

        
        if( XOR === true)
        { 
          setIsCheck([id])  // XOR true és assignatura unica de totes
        }
        else // XOR amb numero es un unic per grup númeric 1,2,3,4,...
        {
          let isCheckDup = []
          let sameXOR = []

          //console.log("XOR",XOR,id,checked)

            llistaAssignatures.map((assignatura) => 
              assignatura.subjects.filter(item => item.XOR === XOR ).map((subject) => { 

                //console.log(subject.id,subject.XOR," === ",XOR)
                return sameXOR.push(subject.id) 
              }))

          //console.log("sameXOR",sameXOR)
          isCheckDup = isCheck.filter(item => !sameXOR.some( item2 => item2 === item ) )

          setIsCheck([...isCheckDup, id])
        }

      } else if( ORD ) {

          let isCheckDup = [...isCheck]
          let isOrdDup = [...props.ordreTriat]

          
          /*
          llistaAssignatures.map((assignatura) => 
            assignatura.subjects.filter(item => item.ORD === ORD ).map((subject) => { 
              
              //console.log(subject.id,subject.XOR," === ",XOR)
                return sameORD.push(subject.id) 
                }))
              */

             setIsCheck([...isCheckDup, id])
             
             if(!isOrdDup[ORD]){
               isOrdDup[ORD] = []
              }
              
              isOrdDup[ORD].push(id)
              
              props.setOrdreTriat( isOrdDup )
            //console.log("iOD",isOrd)
        //console.log("isCheck same",isCheck,rowORD)


      } else {

        let isCheckDup = [...isCheck]

        // assignatures de Castellarnau CFGS Audiologia que son excloents
        if (id === "108.02 I") { isCheckDup = isCheckDup.filter(item => item !== "108.02 II") }
        if (id === "108.02 II") { isCheckDup = isCheckDup.filter(item => item !== "108.02 I") }

        setIsCheck([...isCheckDup, id])

      }
    }
    
  }



  const handleChangeReligio = (t) => {

    //const checkbox = refSubjectsTable.current?.querySelector('#RELIGIO');

    // valor de t: "1" religio o "2" valors   (valor inicial 0)
    props.setAuthReligio(t)

    resetCurs([])

    if(t === "1" ) { // religio seleccionada, cal marcar religio a les assignatures automaticament si no està ja marcat.

      if(!isCheck.includes("RELIGIO"))
      {
        llistaAssignatures.map( (m) => 
          { 
            if(m.id === "ESO1O" || m.id === "ESO2O" || m.id === "ESO3O") 
              m.subjects.map( (s) => { 
                  s.SHOWONLY = true 
                  if(s.id === "RELIGIO") handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
                }
            )
          })
      }


    } else { // valor seleccionats desmarquem assignatura i la posem triable com a opcional (absurd??)


      if(isCheck.includes("RELIGIO"))
      {
        llistaAssignatures.map( (m) => 
          { 
            if(m.id === "ESO1O" || m.id === "ESO2O" || m.id === "ESO3O") 
              m.subjects.map( (s) => { 
                  s.SHOWONLY = false
                  if(s.id === "RELIGIO") handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
                }
            )
          })
      }

      /*
      llistaAssignatures.map( (m) => m.subjects.map( (s) => { if(s.id === "RELIGIO") s.SHOWONLY = false }))
      if(isCheck.includes("RELIGIO"))
      {
        handleClickOnSubject("RELIGIO", isCheck.includes("RELIGIO"), null, null)
      }
        */

    }
  }
  //const refSubjectsTable = useRef();

  const handleClickOnModule = (module) => {

    let isCheckDup = [...isCheck]

    module.subjects.map((subject, index) => {

    //console.log("MODULE", isCheck.includes(subject.id), subject)

    if (isCheck.includes(subject.id)) {
      isCheckDup = (isCheckDup.filter(item => item !== subject.id));
    }
    else {

      // assignatures de CFGS Audiologia que son excloents
      if(subject.id === "108.02 I")  { isCheckDup = isCheckDup.filter(item => item !== "108.02 II") }
      if(subject.id === "108.02 II") { isCheckDup = isCheckDup.filter(item => item !== "108.02 I") }

      isCheckDup = [...isCheckDup, subject.id]
    }

    setIsCheck(isCheckDup)

    } )

    
  }


  /**
   * Mostrar numero d'ordre en cas que hi hagi moduls amb ordre de preferencia
   * 
   */

  const preferenceOrderNumber = (ordreTriat,subject) => {

    //console.log("ORD",ordreTriat,subject.ORD)

    if (subject.ORD) {

    if (ordreTriat[subject.ORD]) {

      let icon

      switch (ordreTriat[subject.ORD].indexOf(subject.id) + 1) {
        case 1:
          icon = fa1; break;
        case 2:
          icon = fa2; break;
        case 3:
          icon = fa3; break;
        case 4:
          icon = fa4; break;
        case 5:
          icon = fa5; break;
        case 6:
          icon = fa6; break;
        case 7:
          icon = fa7; break;
        case 8:
          icon = fa8; break;
        case 9:
          icon = fa9; break;

        default: return (<FontAwesomeIcon icon={fa0} fixedWidth color="transparent" />)
      }

      return (<FontAwesomeIcon icon={icon} fixedWidth />)
    }
  }

    return (<FontAwesomeIcon icon={fa0} fixedWidth color="transparent" />)
  }
  
  
  
  useEffect((e) => {
    
    props.handleChange(isCheck)
    
  }, [isCheck])


  /* si només hi ha una assignatura, la marquem per defecte */
  useEffect((e) => {
  if(llistaAssignatures.length === 1 )
  {
    if (llistaAssignatures[0].subjects.length === 1) {
                                                             //checked XOR  ORD
       handleClickOnSubject(llistaAssignatures[0].subjects[0].id,false,true,false)
    }
  }

},[llistaAssignatures])
  

  let idx_torns = 0;
  if(props.nivellMax>0)  idx_torns = props.nivellMax - 1
  const torns = [{id: "M", value: "Matí"},{id: "T", value: "Tarda"}]

  let tornsenabled = props.curs.torns[idx_torns]

  // forcem al torn obligatori si ens ha vingut donat al moment de comprovar DNI
  if(props.tornObligatori) 
  { 
    tornsenabled = [props.tornObligatori]
  }

  //console.log("TORNS ENA",props.tornObligatori,tornsenabled)
  const errors = {}
  
  return (<div className="col col-12">

    <br/>

    <div id={props.id + '_CONTAINER'} className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs">



                                { config.autoritzacioReligioAbansTriarAssignatures && props.curs?.id.startsWith("ESOLOE") && (<>
                                <br/>
                                <br/>
                                      <div id="religio_CONTAINER" class="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs requadreAutoritzacioReligio" >
                                  <div class="t-Form-labelContainer">
                                        <div className="row">
                                          <div className="col col-12 ">
                                            <h4>
                                              Declaració sobre l'opció per la formació religiosa o valors
                                            </h4>

                                            <p>Aquesta elecció és vàlida durant tota l’etapa educativa d’ESO. En cas de canvi, en finalitzar el curs, s’ha de comunicar a la
                                              Secretaria del centre per a que aquest canvi tingui efectes el curs vinent.</p><br />


                                { props.curs?.id.startsWith("ESOLOE04") ?
                                          (<>
                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "1" ? true : false} onChange={(t) => { handleChangeReligio("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
                                            </label>

                                            <br />

                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "2" ? true : false} onChange={(t) => { handleChangeReligio("2") }} required /> DESITGEM que el/la nostre/a fill/a rebi ENSENYAMENT DE: VALORS
                                            </label>
                                            </>)
                                            :
                                          (<>
                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "1" ? true : false} onChange={(t) => { handleChangeReligio("1") }} required /> DESITGEM que el/la nostre/a fill/a rebi FORMACIÓ RELIGIOSA: CATÒLICA
                                            </label>

                                            <br />

                                            <label>
                                              <input type="radio" id="authReligio" name="authReligio" value={props.authReligio} checked={props.authReligio === "0" ? true : false} onChange={(t) => { handleChangeReligio("0") }} required /> <b>NO</b> DESITGEM que el/la nostre/a fill/a rebi FORMACIO RELIGIOSA: CATÒLICA
                                            </label>
                                            </>)
                                            }

                                            <span id="auhtReligio_ERROR" className="a-Form-error">{errors.authReligio}</span>

                                          </div>
                                        </div>

                                      </div>
                                      </div>
                                    <br />
                                </>)}



{ (!config.autoritzacioReligioAbansTriarAssignatures || !props.curs.id.startsWith("ESO") || props.authReligio ) && (<>

      <div className="t-Form-labelContainer">
        <label for={props.id} id={props.id + '_LABEL'} className="t-Form-label">Tria d'assignatures</label>

        {( props.curs.id === "ESOLOE01" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["ESOLOE01"] && config.textTriarAssignatures["ESOLOE01"] ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["ESOLOE01"] }} /></>)}
        {( props.curs.id.startsWith("ESO") && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["ESO"] ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["ESO"] }} /></>)}
        {( props.curs.id.startsWith("BATX") && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["BATX"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["BATX"] }} /></>)}

        { props.nouAlumne ? (<>
        {( props.cicle === "CFGM" && llistaAssignatures.length > 1 && config.textTriarAssignaturesNous?.["CFGM"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignaturesNous["CFGM"] }} /></>)}
        {( props.cicle === "CFGS" && llistaAssignatures.length > 1 && config.textTriarAssignaturesNous?.["CFGS"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignaturesNous["CFGS"] }} /></>)}
        </>)
        :(<>
        {( props.cicle === "CFGM" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["CFGM"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["CFGM"] }} /></>)}
        {( props.cicle === "CFGS" && llistaAssignatures.length > 1 && config.textTriarAssignatures?.["CFGS"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["CFGS"] }} /></>)}
        </>)}

        {( props.curs.id.startsWith("PFI") && llistaAssignatures.length >= 1 && config.textTriarAssignatures?.["PFI"]  ) && (<><br/><small dangerouslySetInnerHTML={{ __html: config.textTriarAssignatures["PFI"] }} /></>)}

      </div>

       <br/>

      <div className="t-Form-inputContainer">

        <div className="t-Form-itemWrapper">

          <div className="col col-3 ">
            {(llistaAssignatures.length > 1 && config.mostraTorns ) && (
              <FormSelectRadio elements={torns} enabledelements={tornsenabled} col=" col-12" name="torn" value={props.torn} label="Torn" handleChange={props.handleCanviTorn} />
            )}
          </div>

          <div className="col col-1 "> &nbsp;</div>

            { (llistaAssignatures.length > 1 && 
                    ( !props.curs.id.startsWith("ESO") 
                    && !props.curs.id.startsWith("BATX") 
                    && !props.curs.id.startsWith("PFI")  )) 
              && (
                <div className="col col-4 ">
                <label className="t-Form-label">Tria totes les assignatures del curs:</label>
                <table border="0" className="subjectsTable">

                  <tr className="level_1" onClick={() => handleSelectAllLevel(1)}>
                    <td>
                      <label className="t-Form-label">1r curs tot el curs</label>
                    </td>
                  </tr>

                  <tr className="level_2" onClick={() => handleSelectAllLevel(2)}>
                    <td>
                      <label className="t-Form-label">2n curs tot el curs</label>
                    </td>
                  </tr>


                  { props.curs.curs3x2 &&(<tr className="level_all" onClick={() => handleSelectAllLevel("A")}>
                    <td>
                      <label className="t-Form-label">3x2 (doble titulació)</label>
                    </td>
                  </tr>)}
                </table>
              </div>
              )}



          <table border="0" className="subjectsTable">

            {/*
            <tr>
                <th></th>
                <th className="">Codi</th>
                <th className="">Assignatura</th>
                <th className="">Hores</th>
                <th className="">Codi curs</th>
            </tr>
*/}

            {llistaAssignatures.map((module, index) =>
            (
              <React.Fragment>

                  {
                     (module.name.length > 0) && (
                <tr style={{ display: (only) ? "none" : "table-row" }} >
                  <th colspan="1">
                  </th>
                  <th colspan="2">
                     { 
                     ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") ) ?
                      (<label for={module.id} id={module.id + '_LABEL'} className="t-Form-label"><b>{module.name}</b></label>)
                      :
                      (<label for={module.id} id={module.id + '_LABEL'} className="t-Form-label" onClick={() => handleClickOnModule(module)}><b>{module.name}</b></label>) 
                     }
                  </th>
                </tr>
                    )
                  }

                {module.subjects.map((subject, index) =>
                (<tr key={index} className={'level_' + subject.level} 
                                 style={{ display: (only && subject.id !== "ONLY") ? "none" : "table-row", backgroundColor: ( subject.id === "ONLY" || subject.SHOWONLY) ? "lightgrey" : null, cursor: subject.SHOWONLY||subject.INFOONLY ? "default" : "pointer" }} 
                                 onClick={() => { if(!subject.SHOWONLY&&!subject.INFOONLY){ handleClickOnSubject(subject.id, isCheck.includes(subject.id), subject.XOR, subject.ORD )} }}>

                  <td>{ !subject.INFOONLY && (<input type="checkbox" id={subject.id} name="familia" value={subject.id} checked={isCheck.includes(subject.id) /* || subject.SHOWONLY */ } disabled={subject.SHOWONLY ? true : false } readOnly />)}
                  
                  &nbsp;&nbsp;{ (<>{ preferenceOrderNumber(props.ordreTriat,subject)}</>)}
                  </td>
                  {/* subject.preu !== undefined && (<td for={theme.id} id={theme.id + '_LABEL'} className=""><i>{subject.preu}€</i></td>)*/}
                  {/*<td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.id.split(".").pop()}</td>*/}
                  <td for={module.id} id={module.id + '_LABEL'} className="">{subject.name}</td>


                  {/* config.develop && CANVIAT TEMPORALMENT PER CAVALL BERNAT PUGUI COMPROVAR */}
                  { subject.extres != undefined &&
                    (<>
                        { subject.preu && (<td for={module.id} id={module.id + '_LABEL'} className="" style={{color: 'transparent'}}><b>preu:</b>{subject.preu}</td>)}
                        { subject.extres && (<td for={module.id} id={module.id + '_LABEL'} className="" style={{color: 'transparent'}}><b>extres: </b>
                        { Object.keys(subject.extres).map( (extra) =>  (<>{extra}:{subject.extres[extra]} </>) ) }
                        </td>)}
                      </>)}

                  {/*<td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.hours}</td>
                  <td for={theme.id} id={theme.id + '_LABEL'} className="">{subject.assign}</td>*/}
                </tr>))}
              </React.Fragment>
            ))}

          </table>

        </div>

        <span id="{props.id}_ERROR" className="a-Form-error"></span>

      </div>

      </>)}

    </div>


  </div>)


}




/*
 Desplegable que permet triar quin cicle / tipus de curs volem cursar
*/
const TriaCurs = (props) => {

  let fam = props.families[props.cicle].families.filter(f => f.id === props.familia).pop();

  // si el curs te l'atribut nouAlumne només els mostra als que tinguin el mateix valor T/F, mostra a tothom si no està posat
  let cursos = fam.cursos.filter( f => { 
  if( f?.nouAlumne === undefined ) return f 
    else 
      if( f.nouAlumne === props.nouAlumne ) return f 
   })

  //console.log("CURSOS",cursos)

  return (<FormSelectRadio elements={cursos} col=" col-12" name="curs" cursObligatori={props.cursObligatori} value={props.curs?.id} label={props.label} handleChange={props.handleChange} />)

}


/*
 Desplegable que mostra les families de cada cicle
*/
const SeleccionaCicleFamilia = (props) => {

  let col = 3

  if( props.families[props.cicle].families.length > 4 )
  {
     col = 2
  }
  else if( props.families[props.cicle].families.length < 3 )
  {
     col = 4
  }

  return (<FormSelectRadio elements={props.families[props.cicle].families} col={" col-" + col } name="familia" value={props.familia} label={props.label} handleChange={props.handleChange} nouAlumne={props.nouAlumne} />)

}


const YearOptions = () => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 101 }, (_, i) => currentYear - i);

  return (
    <>
      {years.map((year) => (
        <option key={year} value={year}>
          {year}
        </option>
      ))}
    </>
  )
}



/*** FUNCIO PRINCIPAL ***/

//export default function EnrolmentFormStudiesGeneric(props) {
export function EnrolmentFormStudies(props) {

//DEBUG console.log("FAMILIES XXX ",config.families,families)

  const [errors, setErrors] = useState({});

  const [cicle, setCicle] = useState();
  const matriculaDirecta = props.dadesPersonals?.matriculaDirecta === true;

  const [nouAlumne, setNouAlumne] = useState(matriculaDirecta ? true : (props.dadesPersonals?.noPreguntarSiEsNouAlumne === true ? false : undefined));
  const [nPreinscripcio, setNPreinscripcio] = useState('');
  const [titolAccesFile, setTitolAccesFile] = useState()
  const [notesAccesFile, setNotesAccesFile] = useState()
  const [familia, setFamilia] = useState();
  const [curs, setCurs] = useState();
  const [quota, setQuota] = useState();
  const [demanaConvalidacions, setDemanaConvalidacions] = useState("0");
  const [demanaConvalidacionsFile, setDemanaConvalidacionsFile] = useState();
  const [demanaBeca, setDemanaBeca] = useState("0");
  const [observacionsMatricula, setObservacionsMatricula] = useState();
  // Art La Industrial, només monogràfics: substitueix "Observacions tria d'assignatures" per
  // aquesta pregunta; observacionsMatricula es reaprofita com a camp de text per als
  // coneixements previs (mateix estat, etiqueta diferent)
  const [estudisPrevisIndustrial, setEstudisPrevisIndustrial] = useState('');
  const [dadesInscripcioOpen, setDadesInscripcioOpen] = useState(true);
  const [dadesQuotaOpen, setDadesQuotaOpen] = useState(true);
  const [assignatures, setAssignatures] = useState([]);
  const [ordreTriat, setOrdreTriat] = useState([]);
  const [torn, setTorn] = useState('M')
  const [repetidor , setRepetidor ] = useState()
  const [materials, setMaterials] = useState([])
  const [bonificacio, setBonificacio] = useState([])
  const [dosTerminis, setDosTerminis] = useState(config.dosTerminisDefault === true ? true : false)
  const [justificantPagamentFile, setJustificantPagamentFile] = useState()
  const [bonificacioFile, setBonificacioFile] = useState()
  const [notesCursAnteriorFile, setNotesCursAnteriorFile] = useState()
  const [nivellMax, setNivellMax] = useState(0);
  const [families, setFamilies] = useState([]);
  const [assignaturesCatalog, setAssignaturesCatalog] = useState({});

  const [estudisAcces, setEstudisAcces] = useState();
  const [notaAcces, setNotaAcces] = useState();
  const [viaAcces, setViaAcces] = useState();
  const [certificatProvaAccesFile, setCertificatProvaAccesFile ] = useState();
  const [anyEstudisAcces, setAnyEstudisAcces] = useState();
  const [paisEstudisAcces, setPaisEstudisAcces] = useState();

  const [comprovantAcceptacioPlacaFile, setComprovantAcceptacioPlacaFile] = useState()


  const [dadesEstudis, setDadesEstudis] = useState({validat: false});

  const [authReligio, setAuthReligio] = useState();

  const dataNaixement = props.dadesPersonals?.dataNaixement;
  const iddocument = props.dadesPersonals?.iddocument;
  // quan el DNI està admès a més d'un curs (props.dadesPersonals.cursosAdmesos, veure
  // Art La Industrial), el becat depèn de quin dels cursos admesos s'ha triat; en el cas
  // habitual (0 o 1 curs admès) cursosAdmesos no ve informat i es manté el valor fix d'abans
  const admissioCursTriat = props.dadesPersonals?.cursosAdmesos?.find((a) => a.c === curs?.id);
  const becat = admissioCursTriat ? admissioCursTriat.b : props.dadesPersonals?.becat;
  const sexe = props.dadesPersonals?.sexe;
  const germansAlCentre = props.dadesPersonals?.germansAlCentre; //només per JM

  const notesAccesText = config.notesAccesText ?  config.notesAccesText : "notes del curs anterior"


  /* carrega families des de l'API */
  useEffect((e) => {
  fetch(config.apiURL,{ method:'POST', 
    body: JSON.stringify({ cid: config.cid, act: 'getFam' }),
    headers: new Headers({'Content-Type': 'application/json' })})
    .then(res => res.json())
    .then(data => setFamilies(JSON.parse(decode(data.f))))
    .catch((err) => { console.log(err) })
  },[])

  /* carrega el catàleg d'assignatures i les dades bancàries des de l'API (llegeix la taula
     en viu si existeix, o cau als mateixos JSON estàtics que abans es carregaven amb
     require() en temps de build); el catàleg d'assignatures cal també injectar-lo al mòdul
     de quotes, que en fa un ús propi (calculQuota/MostraQuota) independent d'aquest component */
  useEffect((e) => {
  fetch(config.apiURL,{ method:'POST',
    body: JSON.stringify({ cid: config.cid, act: 'getAssignatures' }),
    headers: new Headers({'Content-Type': 'application/json' })})
    .then(res => res.json())
    .then(data => {
      const catalegAssignatures = JSON.parse(decode(data.a))
      setAssignaturesCatalog(catalegAssignatures)
      setCataleg(catalegAssignatures, undefined)
    })
    .catch((err) => { console.log(err) })
  },[])

  useEffect((e) => {
  fetch(config.apiURL,{ method:'POST',
    body: JSON.stringify({ cid: config.cid, act: 'getDadesBancaries' }),
    headers: new Headers({'Content-Type': 'application/json' })})
    .then(res => res.json())
    .then(data => setCataleg(undefined, JSON.parse(decode(data.d))))
    .catch((err) => { console.log(err) })
  },[])


  const ciclesCriteri = cicle ? (cicle.startsWith('CFGS') || cicle.startsWith('CFGM')) : false
  const batxCriteri = cicle ? cicle.startsWith('BATX') : false
  const certificatProvaAccesCriteri = viaAcces ? viaAcces.startsWith("Prova") : false

  const  inValidaEstudis = () => {
    handleDadesEstudis(false)
  }

  const validaEstudis = (e) => {
    e.preventDefault()
  
    let error = {}

    error.quota = quota ? null : "Error: quota de pagament no calculada"

    if (curs.id.startsWith("MONO")) {
      error.estudisPrevisIndustrial = estudisPrevisIndustrial ? null : "Cal triar una opció"
    }

    //només obligatori pels nous de cicles i batxillerat
    if(nouAlumne && !matriculaDirecta && ( ciclesCriteri || batxCriteri )  )
    {
      error.titolAccesFile = titolAccesFile ? null : "Cal adjuntar títol pel qual s'accedeix"
      handleErrors("titolAccesFile",error.titolAccesFile);

      if(config.notesAcces)
      {
        error.notesAccesFile = notesAccesFile ? null : "Cal adjuntar " + notesAccesText
        handleErrors("notesAccesFile",error.notesAccesFile);
      }

      /*
      if(config.comprovantAcceptacioPlaca)
      {
        error.comprovantAcceptacioPlacaFile = comprovantAcceptacioPlacaFile ? null : "Cal adjuntar comprovant"
        handleErrors("comprovantAcceptacioPlacaFile",error.comprovantAcceptacioPlacaFile);
      }
      */

    }
    else
    {
      // TODO  Caldria passar valor al quotes.xxx.js
      //error.repetidor = repetidor !== undefined ? null : "Cal indicar una opció"
      //handleErrors("repetidor",error.repetidor);
    }


      if(nouAlumne && !matriculaDirecta && config.informacioExtraEstudisAcces)
      {

        error.estudisAcces = estudisAcces ? null : "Cal indicar estudis pel qual s'accedeix"

        error.viaAcces = viaAcces ? null : "Cal indicar via per la qual s'accedeix"

        if( certificatProvaAccesCriteri )
        {
           error.certificatProvaAccesFile = certificatProvaAccesFile ? null : "Cal adjuntar certificat de la prova d'accés"
        }

        error.notaAcces = notaAcces ? null : "Cal indicar nota d'accés"

        error.anyEstudisAcces = anyEstudisAcces ? null : "Cal indicar un any"

        error.paisEstudisAcces = anyEstudisAcces ? null : "Cal indicar país"

      }

    if( config.pagamentTPV && quota.total>0 )
    {
      /*error.justificantPagamentFile = justificantPagamentFile ? null : "Cal adjuntar justificant de pagament"
      handleErrors("justificantPagamentFile",error.justificantPagamentFile);*/
    }

    if( config.pagamentTransferencia && quota.total>0 )
    {
      error.justificantPagamentFile = justificantPagamentFile ? null : "Cal adjuntar justificant de pagament"
      handleErrors("justificantPagamentFile",error.justificantPagamentFile);
    }

    if(quota.bonificacio>0 && bonificacio !== "dona")
    {
      error.bonificacioFile = bonificacioFile ? null : "Cal adjuntar justificant de bonificació / exempció "
      handleErrors("bonificacioFile",error.bonificacioFile);
    }

    if( nouAlumne && nivellMax === 2 )
    {
      error.notesCursAnteriorFile = notesCursAnteriorFile ? null : "Cal adjuntar les notes del curs anterior"
      handleErrors("notesCursAnteriorFile",error.notesCursAnteriorFile);
    }

    //console.log("REP 1",config.repetidor,nouAlumne)
    if ( config.repetidor && !nouAlumne )
    {
    //console.log("REP 2",repetidor)
      error.repetidor = repetidor !== null ? null : "Cal indicar si promocioneu o sou repetidors"

    //console.log("REP 3",repetidor)
      handleErrors("repetidor",error.repetidor);
    }


    if( config.repetidorsNoPodenAgafarAssignaturesDe2n )
    {
      if( repetidor === 1 && nivellMax === 2 )
      {
        error.repetidorsNoPodenAgafarAssignaturesDe2n = "Si repeteixes 1r no pots agafar assignatures de 2n"
        handleErrors("repetidosNoPoenAgafarAssignaturesDe2n",error.repetidorsNoPodenAgafarAssignaturesDe2n);
      }

    }


    
    setErrors(error)

    let noError = true;

    if(!config.develop) // bypass errors if develop == true
    {
     Object.keys(error).map( (k) => { if(error[k] !== null) noError = false } )
    }

    handleDadesEstudis(noError)
  
    if(noError)
    {
        setDadesInscripcioOpen(false)
        setDadesQuotaOpen(false)
    }
  
    return false;
  }


  // canvis en dades quota, recaulculem
  useEffect(() => {

  //console.log("ini2",sexe,germansAlCentre,props.dadesPersonals)

    setQuota(calculQuota(curs,assignatures,dataNaixement,repetidor,setRepetidor,materials,setMaterials,setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne, germansAlCentre ));
    inValidaEstudis()

  }, [assignatures,repetidor,dataNaixement,curs,materials, bonificacio, torn, becat, sexe, nouAlumne, germansAlCentre]);

  // alguns cursos monogràfics porten un extra de 70€ de matrícula que només s'ha de cobrar
  // un cop: si l'iddocument ja té algun d'aquests cursos pagat, traiem la línia de material
  // corresponent (tant del preu com de la llista mostrada)
  useEffect(() => {

    if (!curs?.material?.some(m => m.id === 'matricula')) return
    if (!iddocument) return

    let cancelled = false

    axios.post(config.apiURL, {
      cid: config.cid,
      act: 'chkMatricula70',
      iddocument: iddocument,
    }).then(response => {
      if (cancelled) return
      if (response.data.jaPagat70 === 1) {
        setCurs(c => (c?.material?.some(m => m.id === 'matricula'))
          ? { ...c, material: c.material.filter(m => m.id !== 'matricula') }
          : c)
        setMaterials([])
      }
    }).catch((err) => { console.log(err) })

    return () => { cancelled = true }

  }, [curs?.id, iddocument]);

  const handleErrors = (nom, error) => {
    //console.log('error', nom, error)
    setErrors(error)
  }

  const handleFileError = (e,msg) => {
    let err  = {...errors}
    err[e] = msg 
    setErrors(err)
  }

function DropZone(props) {
  const onDrop = useCallback(acceptedFiles => {
    // Do something with the files

    handleErrors(props.id, { justificantPagamentFile: null })

    let file = acceptedFiles[0];

      const MAXSIZE = 4
      if (file.size > MAXSIZE * 1024 * 1024 ) {
        props.handleFileError("Arxiu massa gran màxim " + MAXSIZE + "MB")
        file = undefined
        props.onChange() // buidem file al no ser correcte
      }

    if (file) {

        switch(props.accept)
        {
          case "all":
              break;

          case "+pdf":
              if (!/^image\/png/.test(file.type) 
                  && !/^image\/jpeg/.test(file.type)
                  && !/^application\/pdf/.test(file.type)
                ) {
                file = undefined
                props.onChange() // buidem file al no ser correcte
                props.handleFileError("Tipus d'arxiu no vàlid. S'accepten imatges JPG , PNG o PDF.")
                return false
              }

          default: 
              if (!/^image\/png/.test(file.type) && !/^image\/jpeg/.test(file.type)) {
                file = undefined
                props.onChange() // buidem file al no ser correcte
                props.handleFileError("Tipus d'arxiu no vàlid. S'accepten imatges JPG o PNG.")
                return false
              }
        }

        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          // Do whatever you want with the file contents
          const fileContent = reader.result
          //console.log("BIN", fileContent)

          props.onChange({file: file, fileContent: fileContent})

          //console.log(acceptedFiles[0].name) // size type
        }
        reader.readAsDataURL(file)
    }

  }, [])
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  return (
    <div className="col">
      <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id={props.id + '_CONTAINER'}>
        <div className="t-Form-labelContainer">
          <label for={props.id} id={props.id + '_LABEL'}
            className="t-Form-label">{props.label} <small>{props.labelSmall}</small></label>
        </div>
        <div className="t-Form-inputContainer">
          <div className="t-Form-itemWrapper">
            <div {...getRootProps()} style={{ width: '100%' }}>
              <input {...getInputProps()} />
              {isDragActive && <p>Drop the files here ...</p>}
              {!isDragActive && (<div className="dropZone"> {props.file?.file ? props.file.file.name : props.labelDrop} </div>)}
            </div>
          </div>
          <span id={props.id + '_ERROR'} className="a-Form-error">{props.error}</span>
        </div>
      </div>
    </div>)
}

  const handleCanviCicle = (t) => {
    setCicle(t.target.value)
    setFamilia(null)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviNouAlumne = (t) => {
    setNouAlumne(t.target.value === "1" ? true : false)
    setNPreinscripcio('')
    setCicle(null)
    setFamilia(null)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviFamilia = (f) => {
    setFamilia(f)
    setCurs(null)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviCurs = (c) => {
    let fam = families[cicle].families.filter(f => f.id === familia).pop();
    let cur = fam.cursos.filter(fc => fc.id === c).pop();
    setCurs(cur)
    setAssignatures([])
    setMaterials([])
  }

  const handleCanviAssignatures = (a) => {
    setAssignatures(a)
  }

  const handleCanviTorn = (t) => {
    setTorn(t)
  }

  const handleCanviNivellMax= (n) => {
    console.log("canviNivellMax",n)
    setNivellMax(n)
  }


  const toggleDadesInscripcioOpen = () => {
    setDadesInscripcioOpen(!dadesInscripcioOpen)
  }

  const toggleDadesQuotaOpen = () => {
    setDadesQuotaOpen(!dadesQuotaOpen)
  }

  const handleDadesEstudis = (noError) => {

    const acces = {
      "estudis": estudisAcces,
      "via": viaAcces,
      "nota": notaAcces,
      "anyEstudis": anyEstudisAcces,
      "paisEstudis": paisEstudisAcces
    }

    if( certificatProvaAccesCriteri )
    {
      acces.certificatProvaAccesFile = certificatProvaAccesFile
    }


    let d = {
     "validat": noError,
    /* DADES ESTUDIS */

      "cicle": cicle,
      "nouAlumne": nouAlumne,
      "nPreinscripcio": nPreinscripcio,
      "titolAccesFile": titolAccesFile,
      "notesAccesFile": notesAccesFile,
      "familia": familia,
      "curs": curs,
      "quota": quota,
      "observacionsMatricula": observacionsMatricula,
      "estudisPrevisIndustrial": estudisPrevisIndustrial,
      "dadesInscripcioOpen": dadesInscripcioOpen,
      "dadesQuotaOpen": dadesQuotaOpen,
      "assignatures": assignatures,
      "ordreTriat": ordreTriat,
      "torn": torn,
      "repetidor": repetidor,
      "materials": materials,
      "bonificacions": bonificacio,
      "dosTerminis": dosTerminis,
      "justificantPagamentFile": justificantPagamentFile,
      "bonificacionsFile": bonificacioFile,
      "notesCursAnteriorFile": notesCursAnteriorFile,
      "nivellMax": nivellMax,
      "acces": acces,
      "comprovantAcceptacioPlacaFile": comprovantAcceptacioPlacaFile
    }

    if(config.demanaConvalidacions) d.demanaConvalidacions = demanaConvalidacions
    if(config.demanaBeca) d.demanaBeca = demanaBeca
    if(config.autoritzacioReligioAbansTriarAssignatures) d.authReligio = authReligio
    if(demanaConvalidacionsFile) d.demanaConvalidacionsFile = demanaConvalidacionsFile
  
      setDadesEstudis(d)
      props.handleDadesEstudis(d)
    }

  /*
  recompte d'assignatures amb XOR i ORD  per saber quantes necessitem com a mínim per mostrar ja quota 
  */
 function countNeededSubjects(data) {
   let ordGroupCount = 0;
   let ordSubjectCount = 0;
   let showOnlyCount = 0;
   let optativesESO = 0
   
   data.forEach(group => {
     let groupHasORD = false
     let groupHasXOR = false
     let subjectsCount = 0

     group.subjects.forEach(subject => {

       if ('ORD' in subject) {
         ordSubjectCount++;
          //console.log("ORD",subject.name)
         groupHasORD = true
         if (subject.id.startsWith("ESO1O")) optativesESO++

        } else if ('XOR' in subject) {
          //console.log("XOR",subject.name)
         groupHasXOR = true
        /*} else if ('SHOWONLY' in subject) {
          console.log("SHOWONLY",subject.name)
          showOnlyCount++*/
        }else{
          //console.log("NORMAL",subject.name,subject.id)
          subjectsCount++
        }



      });
      
      if (groupHasORD) {
        //ordGroupCount++
      } else if (groupHasXOR) {
        ordGroupCount++
      } else {
        ordSubjectCount += subjectsCount
      }

    });

    let total = ordGroupCount + ordSubjectCount

    // si han triat religio es bloquegen resta d'optatives per tant no cal comptar-les
   if (config.autoritzacioReligioAbansTriarAssignatures) {
     if (authReligio === "1" ) {
       total -= optativesESO 
      //console.log("aR",total,optativesESO)
     }
   }

    return  total;
  }




  // condicions per mostrar families 
  let mostraFamilies = (cicle && nouAlumne !== undefined) ? true : false

  // condicions per mostrar cicles
  //let mostraSelectCicle = (nouAlumne !== undefined && (nouAlumne === false || (nouAlumne === true && ( nPreinscripcio.length > 0 && titolAccesFile )))) ? true : false


  let potMatricularCicles = matriculaDirecta ? true : (nouAlumne !== undefined &&
                        (nouAlumne === false
                         ||
                        (nouAlumne === true &&
                          (
                            ( nPreinscripcio.length > 0 ||  !config.proporcionarPreinscripcioNous )
                            &&
                            ( titolAccesFile || !config.proporcionarTitolPreinscripcioNous )
                            &&
                            ( notesAccesFile || !config.notesAcces )
                          )
                          )
                        )) ? true : false


  let mostraSelectCicle = (nouAlumne !== undefined ) ? true : false

  let assignaturesCurs = []
  let assignaturesMinimesNecessaries = 1
  let assignaturesTotalsNecessaries = 1

  if(curs)
  {
    // el catàleg arriba de forma asíncrona (API); si encara no ha arribat quan es tria
    // curs, evitem petar amb un array buit en comptes d'undefined
    assignaturesCurs = assignaturesCatalog[curs.id] || []

    assignaturesTotalsNecessaries = countNeededSubjects(assignaturesCurs); 

    //console.log("CURS",assignaturesCurs.length,countNeededSubjects(assignaturesCurs),assignaturesCurs)

    if(curs.id.startsWith("ESO")) assignaturesMinimesNecessaries = countNeededSubjects(assignaturesCurs); 
                             //assignaturesCurs.length //minim una per modul indicat (normalment 1)

     // Si son repetidors amb una assinatura ja és suficient(JM)
    if(curs.id.startsWith("BATX") && (!familia.endsWith("REPETIDORS") && !config.pattern_batx_nocturn.test(curs.id))) assignaturesMinimesNecessaries = countNeededSubjects(assignaturesCurs); 
  }



  return (
            <div className="container">
              <div className="row">
                <div className="col col-12 ">
                  <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">

                    <div className="t-Region-header">
                      <div className="t-Region-headerItems  t-Region-headerItems--controls">
                        <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={() => toggleDadesInscripcioOpen()}>
                          {dadesInscripcioOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                          {!dadesInscripcioOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                        </button>
                      </div>
                      <div className="t-Region-headerItems t-Region-headerItems--title">
                        <h2 className="t-Region-title a-Collapsible-heading">Inscripció</h2>
                      </div>
                      <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
                    </div>

                    <Dropdown open={dadesInscripcioOpen}>
                      <div className="t-Region-bodyWrap">
                        <div className="t-Region-body a-Collapsible-content">

                          <div className="container">
                            <div className="row">
                              <div className="col col-12 ">
                                <div
                                  className="t-Region t-Region--noPadding t-Region--removeHeader t-Region--noBorder t-Region--scrollBody t-Form--noPadding t-Form--leftLabels margin-top-sm">
                                  <div className="t-Region-bodyWrap">
                                    <div className="t-Region-body">
                                      <div className="container">
                                        <div className="row">


                                          { !matriculaDirecta && props.dadesPersonals?.noPreguntarSiEsNouAlumne === false && (<FormSelectNouAlumne id="nouAlumne" label={config.textAlumneNouAlCentre} labelSub={config.textAlumneNouAlCentreSub} nouAlumne={nouAlumne} handleChange={handleCanviNouAlumne} />)}

                                          {nouAlumne && !matriculaDirecta && (
                                          <>


                                            { config.proporcionarPreinscripcioNous && (
                                            <FormInputText id="ninscripcio" col="col-4" name="inscripcio" label="nº de preinscripció*" value={nPreinscripcio} onChange={setNPreinscripcio} size="20" maxLength="20" />
                                            )}


                                            { config.proporcionarTitolPreinscripcioNous && (
                                            <div className="col col-2">
                                              <DropZone id="titolAccesFile" 
                                              file={titolAccesFile} 
                                              onChange={setTitolAccesFile} Pre
                                              label="Adjuntar títol pel qual accedeix*" 
                                              labelDrop="adjuntar títol d'accés" 
                                              error={errors.titolAccesFile} 
                                              handleFileError={ (msg) =>handleFileError('titolAccesFile',msg) }  />
                                            </div>
                                            )}

                                            { config.notesAcces && (
                                              <div className="col col-2">
                                              <DropZone id="notesAccesFile" 
                                              file={notesAccesFile} 
                                              onChange={setNotesAccesFile} 
                                              label={"adjuntar " + notesAccesText + "*"}
                                              labelDrop={"adjuntar " + notesAccesText}
                                              error={errors.notesAccesFile} 
                                              handleFileError={ (msg) =>handleFileError('notesAccesFile',msg) }  />
                                            </div>
                                            )}

                                            { config.comprovantAcceptacioPlaca && (
                                              <div className="col col-2">
                                              <DropZone id="comprovantAcceptacioPlaca" 
                                              file={comprovantAcceptacioPlacaFile} 
                                              onChange={setComprovantAcceptacioPlacaFile} 
                                              label="Comprovant acceptació de plaça" 
                                              labelDrop="adjuntar comprovant" 
                                              error={errors.comprovantAcceptacioPlacaFile} 
                                              handleFileError={ (msg) =>handleFileError('comprovantAcceptacioPlacaFile',msg) }  />
                                            </div>
                                            )}


                                      <div className="row">

                                        <div className="col col-4">
                                          &nbsp;
                                        </div>
                                      </div>
                                      <div className="row">
                                        <div className="col col-8">
                                          <div class="t-Form-labelContainer">
                                              <label className="t-Form-label">
                                                <small>
                                                 { config.textProporcionarPreinscripcioNous ?  
                                                  <small dangerouslySetInnerHTML={{ __html: config.textProporcionarPreinscripcioNous }} />
                                                  : 
                                                  "Cal proporcionar número de preinscripció, adjuntar títol pel qual s'accedeix i les notes del curs anterior per poder proseguir amb la matrícula de CFGM i CFGS."
                                                }
                                                </small>
                                              </label>
                                          </div>
                                        </div>

                                            </div>

                                            </>
                                          )}

                                          </div>


                                      {nouAlumne && !matriculaDirecta && config.informacioExtraEstudisAcces && (

                                        <div className="row">

                                          <div className="col col-2">
                                            <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="estudisAcces_CONTAINER">
                                              <div className="t-Form-labelContainer">
                                                <label htmlFor="estudisAcces" id="estudisAcces_LABEL" className="t-Form-label">Estudis accés: </label>
                                                <span className="t-Form-required">
                                                  <span className="a-Icon">*</span>
                                                </span>
                                              </div>

                                              <div className="t-Form-inputContainer">
                                                <div className="t-Form-itemWrapper">
                                                  <select id="estudisAcces" name="estudisAcces" defaultValue={estudisAcces} className="selectlist" size="1" onChange={(e) => setEstudisAcces(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="ESO" >ESO</option>
                                                    <option value="BATX" >Batxillerat</option>
                                                    <option value="ALTRES" >Altres</option>
                                                  </select></div>
                                                <span id="estudisAcces_ERROR" className="a-Form-error">{errors.estudisAcces}</span>
                                              </div>
                                            </div>
                                          </div>

                                          <FormInputText id="notaAcces" name="notaAcces" col="col-1" label="Nota d'Accés" value={notaAcces} obligatori={true} size="3" maxLength="5" onChange={setNotaAcces} valida={true} error={errors.notaAcces} />

                                          <div className="col col-2">
                                            <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="viaAcces_CONTAINER">
                                              <div className="t-Form-labelContainer">
                                                <label htmlFor="viaAcces" id="viaAcces_LABEL" className="t-Form-label">Via d'accés: </label>
                                                <span className="t-Form-required">
                                                  <span className="a-Icon">*</span>
                                                </span>
                                              </div>

                                              <div className="t-Form-inputContainer">
                                                <div className="t-Form-itemWrapper">
                                                  <select id="viaAcces" name="viaAcces" defaultValue={viaAcces} className="selectlist" size="1" onChange={(e) => setViaAcces(e.target.value)}>
                                                    <option value=""></option>
                                                    <option value="AccesDirecte" >Accés directe (batxillerat artístic, cicle artístic o grau artístic) </option>
                                                    <option value="ProvaGeneral" >Prova general</option>
                                                    <option value="ProvaEspecifica" >Prova específica</option>
                                                  </select></div>
                                                <span id="viaAcces_ERROR" className="a-Form-error">{errors.viaAcces}</span>
                                              </div>
                                            </div>
                                          </div>


                                          { certificatProvaAccesCriteri && (
                                              <div className="col col-2">
                                              <DropZone id="certificatProvaAccesFile" 
                                              file={certificatProvaAccesFile} 
                                              onChange={setCertificatProvaAccesFile} 
                                              label="Certificat prova d'accés*" 
                                              labelDrop="adjuntar certificat" 
                                              error={errors.certificatProvaAccesFile} 
                                              handleFileError={ (msg) =>handleFileError('certificatProvaAccesFile',msg) }  />
                                            </div>
                                          )}

                                          <div className="col col-2">
                                            <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="anyEstudisAcces_CONTAINER">
                                              <div className="t-Form-labelContainer">
                                                <label htmlFor="anyEstudisAcces" id="anyEstudisAcces_LABEL" className="t-Form-label">Any de finalització d'estudis: </label>
                                                <span className="t-Form-required">
                                                  <span className="a-Icon">*</span>
                                                </span>
                                              </div>

                                              <div className="t-Form-inputContainer">
                                                <div className="t-Form-itemWrapper">
                                                  <select id="anyEstudisAcces" name="anyEstudisAcces" defaultValue={anyEstudisAcces} className="selectlist" size="1" onChange={(e) => setAnyEstudisAcces(e.target.value)}>
                                                    <option value="">Tria any</option>
                                                      <YearOptions />
                                                  </select></div>
                                                <span id="anyEstudisAcces_ERROR" className="a-Form-error">{errors.anyEstudisAcces}</span>
                                              </div>
                                            </div>
                                          </div>



                                          <FormInputText id="paisEstudisAcces" name="paisEstudisAcces" col="col-3" label="País de finalització dels estudisAcces" value={paisEstudisAcces} obligatori={true} size="3" maxLength="50" onChange={setPaisEstudisAcces} valida={true} error={errors.notaAcces} />

                                        </div>
                                      )}


                                          <br/>

                                      <div className="row">

                                          {mostraSelectCicle && (<FormSelectCicle
                                                                  id="cicle"
                                                                  label="Nivell d'estudis pels que fas la matrícula:"
                                                                  potMatricularCicles={potMatricularCicles}
                                                                  nouAlumne={nouAlumne}
                                                                  cicle={cicle}
                                                                  handleChange={handleCanviCicle}
                                                                  families={families}
                                                                  iddocument={props.dadesPersonals?.iddocument}
                                                                  iddocumentNoAdmes={config.validaIDdocumentsFalsePermetMatricular ? props.dadesPersonals?.iddocumentNoAdmes : false}
                                                                  cursObligatori={props.dadesPersonals?.cursObligatori}
                                                                  />)}

                                          {mostraFamilies && cicle && families[cicle] && (<SeleccionaCicleFamilia
                                                                        label="Família"
                                                                        cicle={cicle}
                                                                        families={families}
                                                                        familia={familia}
                                                                        nouAlumne={nouAlumne}
                                                                        handleChange={handleCanviFamilia}
                                                                        />)}


                                          {mostraFamilies && familia && families[cicle] && (<TriaCurs cicle={cicle}
                                                                                   familia={familia}
                                                                                   families={families}
                                                                                   nouAlumne={nouAlumne}
                                                                                   curs={curs}
                                                                                   cursObligatori={props.dadesPersonals?.cursObligatori}
                                                                                   label="Tria curs (tria el curs que faràs)"
                                                                                   handleChange={handleCanviCurs} />)}


                                          {mostraFamilies && familia && curs && (<TriaAssignatures curs={curs} handleChange={handleCanviAssignatures}
                                                                                                   assignaturesCatalog={assignaturesCatalog}
                                                                                                   cicle={cicle}
                                                                                                   nouAlumne={nouAlumne}
                                                                                                   torn={torn} handleCanviTorn={handleCanviTorn} 
                                                                                                   nivellMax={nivellMax} handleCanviNivellMax={handleCanviNivellMax} 
                                                                                                   tornObligatori={admissioCursTriat ? admissioCursTriat.t : props.dadesPersonals?.tornObligatori}
                                                                                                   repetidor={repetidor} setRepetidor={setRepetidor}
                                                                                                   ordreTriat={ordreTriat} setOrdreTriat={setOrdreTriat}
                                                                                                   authReligio={authReligio} setAuthReligio={setAuthReligio}
                                                                                                   />)}

  
                                                                                {/* PF: esperem a que hagin marcat autoritzacio previa per mostrar comentaris*/}
                                          {mostraFamilies && familia && curs && (!config.autoritzacioReligioAbansTriarAssignatures || !curs.id.startsWith("ESO") || authReligio > 0 ) && 
                                          
                                          (<>

                                          {config.demanaBeca && (
                                            <>
                                            <div className="col col-3">
                                              <br></br>
                                              <div className="t-Form-labelContainer t-Form-label">
                                              <input type="checkbox" id="demanaBeca" name="demanaBeca" value={demanaBeca} checked={demanaBeca === "1" ? true : false} onChange={(t) => { setDemanaBeca(t.target.value === "1" ? "0" : "1") }}/>
                                                <label htmlFor="demanaBeca">
                                                  Has demanat beca?
                                                </label>
                                              </div>
                                              <span id="demanaBeca_ERROR" className="a-Form-error">{errors.demanaBeca}</span>
                                            </div>
                                              </>)}

                                          {config.demanaConvalidacions && ciclesCriteri && (
                                            <>
                                            <div className="col col-4">
                                              <br></br>
                                              <div className="t-Form-labelContainer t-Form-label">
                                              <input type="checkbox" id="demanaConvalidacions" name="demanaConvalidacions" value={demanaConvalidacions} checked={demanaConvalidacions === "1" ? true : false} onChange={(t) => { setDemanaConvalidacions(t.target.value === "1" ? "0" : "1") }}/>
                                                <label htmlFor="demanaConvalidacions">
                                                  Demanaràs convalidació d'assignatures?`
                                                </label>
                                              </div>
                                              <br></br>
                                              <span id="demanaConvalidacions_ERROR" className="a-Form-error">{errors.demanaConvalidacions}</span>
                                              { demanaConvalidacions === "1" && 

                                            (<>
                                              <p id="demanaConvalidacions_INFO" className="a-Form-text">
                                                <i dangerouslySetInnerHTML={{ __html: config.demanaConvalidacionsText }} />
                                              </p>

                                              {demanaConvalidacions === "1" && config.demanaConvalidacionsFile === true && (
                                                <div className="col col-12">
                                                  <DropZone id="demanaConvalidacionsFile"
                                                    file={demanaConvalidacionsFile}
                                                    accept="all"
                                                    onChange={setDemanaConvalidacionsFile}
                                                    label="Adjuntar documentació per convalidacions"
                                                    labelDrop="adjuntar documentació"
                                                    error={errors.justificantPagamentFile}
                                                    handleFileError={(msg) => handleFileError('demanaConvalidacioFile', msg)} />
                                                </div>)}

                                            </>)}

                                            </div>
                                          </>)}
                                          
                                          { curs.id.startsWith("MONO") ? (<>

                                            <div className="col col-4">
                                              <div className="t-Form-fieldContainer t-Form-fieldContainer--stacked t-Form-fieldContainer--stretchInputs" id="estudisPrevisIndustrial_CONTAINER">
                                                <div className="t-Form-labelContainer">
                                                  <label htmlFor="estudisPrevisIndustrial" id="estudisPrevisIndustrial_LABEL" className="t-Form-label">Has cursat estudis a La Industrial anteriorment?</label>
                                                  <span className="t-Form-required">
                                                    <span className="a-Icon">*</span>
                                                  </span>
                                                </div>

                                                <div className="t-Form-inputContainer">
                                                  <div className="t-Form-itemWrapper">
                                                    <select id="estudisPrevisIndustrial" name="estudisPrevisIndustrial" defaultValue={estudisPrevisIndustrial} className="selectlist" size="1" onChange={(e) => setEstudisPrevisIndustrial(e.target.value)}>
                                                      <option value=""></option>
                                                      <option value="NO">No</option>
                                                      <option value="MONOGRAFIC">Monogràfic</option>
                                                      <option value="CICLE">Cicle Formatiu</option>
                                                      <option value="BATX">Batxillerat</option>
                                                    </select></div>
                                                  <span id="estudisPrevisIndustrial_ERROR" className="a-Form-error">{errors.estudisPrevisIndustrial}</span>
                                                </div>
                                              </div>
                                            </div>

                                            <FormTextArea
                                                id="observacionsMatricula"
                                                name="observacionsMatricula"
                                                label="Si tens coneixements previs indica quina formació has realitzat"
                                                obligatori={false}
                                                rows="5"
                                                cols="80"
                                                maxLength="1000"
                                                value={observacionsMatricula}
                                                onChange={setObservacionsMatricula}
                                                error={errors.observacionsMatricula}
                                                />

                                          </>) : (

                                          <FormTextArea
                                              id="observacionsMatricula"
                                              name="observacionsMatricula"
                                              label="Observacions tria d'assignatures"
                                              placeHolder={ (config.batxilleratNocturnText && config.pattern_batx_nocturn.test(curs.id)) ? config.batxilleratNocturnText : ""}
                                              obligatori={false}
                                              rows="5"
                                              cols="80"
                                              maxLength="1000"
                                              value={observacionsMatricula}
                                              onChange={setObservacionsMatricula}
                                              error={errors.observacionsMatricula}
                                              />

                                          )}

                                              
                                              </>
                                              )}


                                        </div>
                                      </div>

                                    </div>
                                  </div>
                                </div>


                              </div>
                            </div>

                          </div>

                        </div>
                      </div>
                    </Dropdown>

                  </div>
                </div>
              </div>


      {
        /* s'ha d'haver triat minim una assignatura per mostrar quota */
        /* sense condicions si no es ESO o BATX */
        /* amb condicions de triar totes les modals i optatives si es ESO o BATXILLERAT */
        /*
        ( assignatures.length > 0
          &&
          (
            ((!curs.id.startsWith("ESO") && !curs.id.startsWith("BATX")))
            ||
            ((curs.id.startsWith("ESO") || curs.id.startsWith("BATX")) && assignatures.length === assignaturesCurs.length))
        )*/
        assignatures.length >= assignaturesMinimesNecessaries
        && (
                <div className="container">
                  <div className="row">
                    <div className="col col-12 ">
                      <div className="t-Region t-Region--hideShow is-expanded t-Region--scrollBody t-Form--noPadding margin-top-sm margin-bottom-none margin-left-none margin-right-none a-Collapsible">

                        <div className="t-Region-header">
                          <div className="t-Region-headerItems  t-Region-headerItems--controls">
                            <button className="t-Button t-Button--icon t-Button--hideShow" type="button" onClick={() => toggleDadesQuotaOpen()}>
                              {dadesQuotaOpen && <FontAwesomeIcon icon={faChevronUp} fontSize="18" className="t-Icon" />}
                              {!dadesQuotaOpen && <FontAwesomeIcon icon={faChevronDown} fontSize="18" className="t-Icon" />}
                            </button>
                          </div>
                          <div className="t-Region-headerItems t-Region-headerItems--title">
                            <h2 className="t-Region-title a-Collapsible-heading">Quota d'inscripció</h2>
                          </div>
                          <div className="t-Region-headerItems t-Region-headerItems--buttons"></div>
                        </div>


                        <Dropdown open={dadesQuotaOpen}>
                        <div className="t-Region-bodyWrap">
                          <div className="t-Region-body a-Collapsible-content">

                            <div className="container">
                              <div className="row">
                                <div className="col col-12 ">
                                  <MostraQuota curs={curs} 
                                               cicle={cicle}
                                               quota={quota} 
                                               assignatures={assignatures} 
                                               nouAlumne={nouAlumne}

                                               repetidor={repetidor} setRepetidor={setRepetidor} error={errors}
                                               materials={materials} setMaterials={setMaterials} 
                                               bonificacions={bonificacio} setBonificacions={setBonificacio} 
                                               dosTerminis={dosTerminis} setDosTerminis={setDosTerminis} 

                                               nivellMax={nivellMax}

                                               iddocument={iddocument}
                                               becat={becat}
                                               sexe={sexe}
                                               germansAlCentre={germansAlCentre}

                                               assignaturesMinimesNecessaries={assignaturesMinimesNecessaries}
                                               assignaturesTotalsNecessaries={assignaturesTotalsNecessaries}
                                               />
                                </div>

                          <div className="row" style={{ paddingTop: '2rem'}}>


                            { config.pagamentTransferencia && ( quota?.total > 0 && (
                              <div className="col col-4">
                                <DropZone id="justificantPagamentFile" 
                                file={justificantPagamentFile} 
                                onChange={setJustificantPagamentFile} 
                                label="Adjuntar justificant del pagament*" 
                                labelDrop="adjuntar justificant" 
                                error={errors.justificantPagamentFile} 
                                handleFileError={ (msg) =>handleFileError('justificantPagamentFile',msg) }  />
                              </div>))}

                            { (quota?.bonificacio > 0 && bonificacio !== "dona") &&
                             ( <div className="col col-4">
                                <DropZone id="bonificacionsFile" file={bonificacioFile} onChange={setBonificacioFile} label="Adjuntar justificant del bonificació/exempció*" labelDrop="adjuntar justificant" error={errors.bonificacioFile} 
                                handleFileError={ (msg) =>handleFileError('bonificacionsFile',msg) }  />
                              </div>)}

                            { nouAlumne && ( nivellMax === 2 && (
                              <div className="col col-4">
                                <DropZone id="notesCursAnteriorFile" file={notesCursAnteriorFile} onChange={setNotesCursAnteriorFile} label="Per alumnes nous que vulguin UF de 2n curs cal adjuntar notes curs anterior*" labelDrop="adjuntar notes curs anterior" error={errors.notesCursAnteriorFile} 
                                handleFileError={ (msg) =>handleFileError('notesCursAnteriorFile',msg) }  />
                              </div>))}


                          </div>
                              </div>


                            </div>

                          </div>
                        </div>

                          <div className="container">
                            <div className="row">
                              <div className="col col-12" align="center">
                                <button onClick={validaEstudis} className="button">SEGÜENT</button>
                              </div>
                            </div>
                          </div>

                        </Dropdown>

                      </div>

                    </div>
                  </div>

                </div>)
              }
            </div>


  );
}